import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class FeedbackService {
    async fetch(page = 1, perPage = 10, search = null, status = null) {
        let params = `page=${page}&perPage=${perPage}`;
        if (search) params += `&search=${search}`;
        if (status) params += `&status=${status}`;
        const response = await ajaxService.get(`/feedback?${params}`);
        if (response ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }
    async add(data) {
        const response = await ajaxService.post(`/customer-feedback`, data);
        if (response?.success ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

    async resolve(id, data) {
        const response = await ajaxService.post(`/feedbacks/${id}/resolve`, data);
        if (response ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

    // async deleteEmployee(id) {
    //     const response = await ajaxService.delete(`/employees/`, id);
    //     if (response ?? false) {
    //         return response;
    //     }
    // }
}

const feedbackService = new FeedbackService();
export default feedbackService;
